import { render, staticRenderFns } from "./ChatPanel.vue?vue&type=template&id=2e5408a0&scoped=true&"
import script from "./ChatPanel.vue?vue&type=script&lang=js&"
export * from "./ChatPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatPanel.vue?vue&type=style&index=0&id=2e5408a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5408a0",
  null
  
)

export default component.exports